import { Recipient } from '@bonusly/recipient-entities';

type Content = {
	type: string;
	attrs?: Record<string, any>;
	text?: string;
};

export const createRecipientContent = (recipient: Recipient) => {
	return [
		{ type: 'recipient', attrs: { id: recipient.username, record: recipient } },
		{ type: 'text', text: ' ' },
	] as Content[];
};

export const createAmountContent = (amount: number) => {
	return [
		{ type: 'amount', attrs: { id: amount.toString() } },
		{ type: 'text', text: ' ' },
	] as Content[];
};

export const createHashtagContent = (hashtag: string) => {
	return [
		{ type: 'text', text: ' ' },
		{ type: 'hashtag', attrs: { id: hashtag } },
	] as Content[];
};

export const createRecognitionContent = (recipient: Recipient, text?: string, amount?: number, hashtags?: string[]) => {
	const content = createRecipientContent(recipient);

	// Add amount if provided
	if (amount !== undefined && amount > 0) {
		content.push(...createAmountContent(amount));
	}

	// Add text if provided
	if (text) {
		content.push({
			type: 'text',
			text: text,
		});
	}

	// Add hashtags if provided
	if (hashtags && hashtags.length > 0) {
		hashtags.forEach((hashtag) => {
			content.push(...createHashtagContent(hashtag));
		});
	}

	return {
		type: 'doc',
		content: [
			{
				type: 'paragraph',
				content: content,
			},
		],
	};
};
